import React from 'react';
import { bookingShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { StyledDiv, StyledH2 } from './styles';
import PropTypes from 'prop-types';

const BookingDetails = ({ booking, isReviewQuote = false }) => {
  const bookingReference = booking.externalBookingReferences.find((ref) => ref?.source === 'MASTER')?.externalId || 'Not Assigned';
  const numbersOfPassengers = booking.outbound
    .map((out) => out.products?.filter((p) => !p.cancelled)?.map((l) => l.passenger?.id))
    ?.flat()?.length;

  return (
    <>
      <StyledH2>
        <FormattedMessage id="quoteConfirmation.bookingDetails" />
      </StyledH2>
      <StyledDiv>
        {!isReviewQuote && (
          <>
            <p data-testid="bookingDetails-bookingReference">
              <FormattedMessage id="quoteConfirmation.bookingReference" />: {bookingReference}
            </p>
            <p data-testid="bookingDetails-PNR">
              <FormattedMessage id="quoteConfirmation.PNR" />: {booking.reference}
            </p>
          </>
        )}
        {booking.customer.companyName ? (
          <p data-testid="bookingDetails-companyName">
            <FormattedMessage id="quoteConfirmation.groupName" />: {booking.customer.companyName}
          </p>
        ) : null}
        <p data-testid="bookingDetails-totalPassengers">
          <FormattedMessage id="quoteConfirmation.totalPassengers" />: {numbersOfPassengers}
        </p>
      </StyledDiv>
    </>
  );
};

BookingDetails.propTypes = {
  booking: bookingShape.isRequired,
  isReviewQuote: PropTypes.bool
};

export default BookingDetails;
